/*
 * @Author: Scarlett Xiao
 * @Date: 2022-02-23 14:26:11
 * @LastEditors: zcy
 * @LastEditTime: 2022-03-23 17:22:19
 */

const randum = function (max) {
  return Math.round(Math.random() * max);
}

const hexify = function (x) {
  return ('0' + parseInt(x).toString(16)).slice(-2);
}
// 随机生成hex颜色
const randex = function () {
  return '#' + hexify(randum(255)) + hexify(randum(255)) + hexify(randum(255));
};

const blender = function () {
  if (!!Math.round(Math.random())) {
    return 'radial-gradient(circle at ' + randum(100) + '% ' + randum(100) + '%, ' + randex() + ', ' + randex() + ')';
  } else {
    return 'linear-gradient(' + randum(360) + 'deg, ' + randex() + ', ' + randex() + ')';
  }
};

//随机生成rgb颜色
const handleColors = function () {
  let color = '';
  let r = Math.floor(Math.random() * 256);
  let g = Math.floor(Math.random() * 256);
  let b = Math.floor(Math.random() * 256);
  color = `rgba(${r},${g},${b})`;
  return color; //所有方法的拼接都可以用ES6新特性`其他字符串{$变量名}`替换
}

//随机生成rgba颜色
const handleColorsTwo = function () {
  let color = '';
  let r = Math.floor(Math.random() * 256);
  let g = Math.floor(Math.random() * 256);
  let b = Math.floor(Math.random() * 256);
  color = `${r},${g},${b}`;
  return color; //所有方法的拼接都可以用ES6新特性`其他字符串{$变量名}`替换
}

//随机生成深色颜色
const getRandomColor = function () {
  return '#' +
    (function (color) {
      return (color += '0123401234abcabc' [Math.floor(Math.random() * 16)]) &&
        (color.length == 6) ? color : arguments.callee(color);
    })('');
}

//随机生成浅色颜色
const getColorUndertint = function () {
  return '#' +
    (function (color) {
      return (color += '5678956789defdef' [Math.floor(Math.random() * 16)]) &&
        (color.length == 6) ? color : arguments.callee(color);
    })('');
}

// 将rgb表示方式转换为hex表示方式
const colorToHex = function (rgb) {
  const _this = rgb;
  const reg = /^#([0-9a-fA-f]{3}|[0-9a-fA-f]{6})$/;
  if (/^(rgb|RGB)/.test(_this)) {
    const aColor = _this.replace(/(?:\(|\)|rgb|RGB)*/g, "").split(",");
    let strHex = "#";
    for (let i = 0; i < aColor.length; i++) {
      let hex = Number(aColor[i]).toString(16);
      hex = hex < 10 ? 0 + '' + hex : hex; // 保证每个rgb的值为2位
      if (hex === "0") {
        hex += hex;
      }
      strHex += hex;
    }
    if (strHex.length !== 7) {
      strHex = _this;
    }

    return strHex;
  } else if (reg.test(_this)) {
    const aNum = _this.replace(/#/, "").split("");
    if (aNum.length === 6) {
      return _this;
    } else if (aNum.length === 3) {
      let numHex = "#";
      for (let i = 0; i < aNum.length; i += 1) {
        numHex += (aNum[i] + aNum[i]);
      }
      return numHex;
    }
  } else {
    return _this;
  }
}

/**
 * 将hex表示方式转换为rgb
 * @param {String} hexColor 颜色十六进制
 * @return {Array} [r, g, b]格式
 */
const colorToRgb = function (hexColor) {
  const reg = /^#([0-9a-fA-f]{3}|[0-9a-fA-f]{6})$/
  const sColor = hexColor.toLowerCase()
  if (sColor && reg.test(sColor)) {
    if (sColor.length === 4) {
      let sColorNew = "#"
      for (let i = 1; i < 4; i += 1) {
        sColorNew += sColor.slice(i, i + 1).concat(sColor.slice(i, i + 1))
      }
      sColor = sColorNew
    }
    //处理六位的颜色值
    let sColorChange = []
    for (let i = 1; i < 7; i += 2) {
      sColorChange.push(parseInt("0x" + sColor.slice(i, i + 2)))
    }
    return sColorChange
  } else {
    return sColor
  }
}

// 
const getItemColors = function (hex, colorLevel) {
  const colors = [];
  //默认的最深颜色
  // const [red, green, blue] = [Math.floor(Math.random() * 256), Math.floor(Math.random() * 256), Math.floor(Math.random() * 256)];
  var [red, green, blue] = colorToRgb(hex);
  //最浅颜色是239,239,239 比如：最浅颜色的red是 239 则差值为239-134=105 
  //var maxRed = 105,maxGreen = 131,maxBlue = 55; 
  const [maxRed, maxGreen, maxBlue] = [239 - red, 239 - green, 239 - blue];
  let level = colorLevel;
  while (level--) {
    colors.push('rgb(' + red + ',' + green + ',' + blue + ')');
    red += parseInt(maxRed / colorLevel);
    green += parseInt(maxGreen / colorLevel);
    blue += parseInt(maxBlue / colorLevel);
  }
  // var color = 'linear-gradient(0deg, ' + colorToHex(colors[0]) + ', ' + colorToHex(colors[colors.length - 1]) + ')';
  return colors;
};

// ---------------------------------------------
export default {
  randex, // 随机生成hex颜色
  handleColors, // 随机生成rgb颜色
  getItemColors, // 获取css渐变色
  handleColorsTwo,//随机生成rgba数值
}